/* Zeker Empty Cart v5 - Sin lag */
(function(){
  var zkCarouselLoaded=false,zkCarouselLoading=false,lastItemCount=-1,lastOpen=false;

  function zkEnhanceEmptyCart(){
    var drawer=document.getElementById('CartDrawer');
    if(!drawer)return;
    var rows=drawer.querySelectorAll('tr.cart-item');
    var isEmpty=rows.length===0;
    if(!isEmpty){var h=drawer.querySelector('h3');if(h&&(h.textContent.includes('vac')||h.textContent.includes('empty')))isEmpty=true;}
    if(!isEmpty)return;
    drawer.querySelectorAll('a').forEach(function(a){if(a.textContent.trim().toLowerCase().includes('seguir'))a.href='/collections/todos-los-productos';});
    drawer.querySelectorAll('p').forEach(function(p){var t=p.textContent;if(t.includes('Inicia')||t.includes('cuenta')||t.includes('Tener')||t.includes('rápido'))p.style.display='none';});
    drawer.querySelectorAll('.mt-16').forEach(function(el){el.style.display='none';});
    if(zkCarouselLoaded||zkCarouselLoading)return;
    if(document.getElementById('zk-empty-carousel')){zkCarouselLoaded=true;return;}
    zkCarouselLoading=true;
    fetch('/collections/top-ventas/products.json?limit=4')
    .then(function(r){return r.json();}).catch(function(){return{products:[]};}).then(function(data){
      var p=data.products||[];
      if(!p.length)return fetch('/collections/camaras-de-seguridad/products.json?limit=4').then(function(r){return r.json();}).catch(function(){return{products:[]};});
      return{products:p};
    }).then(function(data){
      var products=(data.products||[]).slice(0,4);
      if(!products.length||document.getElementById('zk-empty-carousel')){zkCarouselLoading=false;return;}
      var carousel=document.createElement('div');
      carousel.id='zk-empty-carousel';
      carousel.style.cssText='padding:14px 16px 16px;border-top:1px solid #eee;';
      carousel.innerHTML='<p style="font-size:11px;font-weight:700;color:#555;text-transform:uppercase;letter-spacing:0.8px;margin-bottom:10px;text-align:center;">🔥 Los más vendidos</p>'
        +'<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">'
        +products.map(function(p){
          var img=p.images&&p.images[0]?p.images[0].src.split('?')[0]+'?width=300&height=300&crop=center':'';
          var price='$'+Math.round(parseFloat(p.variants[0].price)).toLocaleString('es-CL');
          return '<a href="/products/'+p.handle+'" style="text-decoration:none;border:1px solid #eee;border-radius:8px;overflow:hidden;display:block;background:white;">'
            +'<div style="width:100%;padding-bottom:100%;position:relative;background:#f5f5f5;">'
            +(img?'<img src="'+img+'" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;">':'')
            +'</div><div style="padding:8px;"><p style="font-size:10px;color:#111;font-weight:600;line-height:1.3;margin-bottom:3px;">'+p.title.substring(0,38)+'</p>'
            +'<p style="font-size:13px;color:#BD0010;font-weight:800;">'+price+'</p></div></a>';
        }).join('')+'</div>';
      var c=drawer.querySelector('.flex-col.justify-center,.pt-14,.pl-6.pr-6');
      if(c)c.appendChild(carousel);
      else{var s=drawer.querySelector('.overflow-auto');if(s)s.appendChild(carousel);}
      zkCarouselLoaded=true;zkCarouselLoading=false;
    }).catch(function(){zkCarouselLoading=false;});
  }

  setInterval(function(){
    var isOpen=false,itemCount=0;
    try{if(window.Alpine){var s=Alpine.store('xMiniCart');isOpen=!!(s&&s.open);}}catch(e){}
    var d=document.getElementById('CartDrawer');
    if(d)itemCount=d.querySelectorAll('tr.cart-item').length;
    if(lastItemCount>0&&itemCount===0){zkCarouselLoaded=false;zkCarouselLoading=false;var old=document.getElementById('zk-empty-carousel');if(old&&old.parentNode)old.parentNode.removeChild(old);setTimeout(zkEnhanceEmptyCart,600);}
    if(isOpen&&!lastOpen&&itemCount===0){zkCarouselLoaded=false;zkCarouselLoading=false;setTimeout(zkEnhanceEmptyCart,500);}
    if(!isOpen&&lastOpen)zkCarouselLoaded=false;
    lastOpen=isOpen;lastItemCount=itemCount;
  },1000);

  document.addEventListener('DOMContentLoaded',function(){setTimeout(zkEnhanceEmptyCart,1200);});
})();